module.exports = __webpack_public_path__ + "static/media/scarf.29a7a2b9.svg";